import { render, staticRenderFns } from "./Baskets.vue?vue&type=template&id=f54ec46a&scoped=true&"
import script from "./Baskets.vue?vue&type=script&lang=js&"
export * from "./Baskets.vue?vue&type=script&lang=js&"
import style0 from "./Baskets.vue?vue&type=style&index=0&id=f54ec46a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54ec46a",
  null
  
)

export default component.exports